import { useState } from "react";
import { toast } from "react-toastify";
import { sendContactNotification } from "../services/sendNotification";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid.";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required.";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();

    // Add dummy field into formdata named subject
    const updatedFormData = {
      ...formData,
      title: "New Contact Form Submission",
    };

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const res = await sendContactNotification(updatedFormData);
    if (res.status === 200) {
      setFormData({ name: "", email: "", message: "" });
      setErrors({});
      toast.success("Thank you for reaching out! We’ll get back to you soon.");
    } else {
      toast.error("Something went wrong. Please try again later.");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 p-8 rounded-2xl shadow-xl h-full flex flex-col justify-center border border-gray-700"
    >
      <h2 className="text-3xl font-semibold mb-6 text-white tracking-wide text-center">
        Get in Touch
      </h2>

      {/* Name Field */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Name
        </label>
        <input
          type="text"
          name="name"
          onChange={handleChange}
          value={formData.name}
          className={`w-full p-3 text-sm bg-gray-700 text-white border ${
            errors.name ? "border-red-500" : "border-gray-600"
          } rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition`}
        />
        {errors.name && (
          <p className="text-red-500 text-xs mt-1">{errors.name}</p>
        )}
      </div>

      {/* Email Field */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Email
        </label>
        <input
          type="email"
          name="email"
          onChange={handleChange}
          value={formData.email}
          className={`w-full p-3 text-sm bg-gray-700 text-white border ${
            errors.email ? "border-red-500" : "border-gray-600"
          } rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition`}
        />
        {errors.email && (
          <p className="text-red-500 text-xs mt-1">{errors.email}</p>
        )}
      </div>

      {/* Message Field */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Message
        </label>
        <textarea
          name="message"
          rows="4"
          onChange={handleChange}
          value={formData.message}
          className={`w-full p-3 text-sm bg-gray-700 text-white border ${
            errors.message ? "border-red-500" : "border-gray-600"
          } rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition`}
        ></textarea>
        {errors.message && (
          <p className="text-red-500 text-xs mt-1">{errors.message}</p>
        )}
      </div>

      <button
        type="submit"
        className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-medium transition-all duration-300"
      >
        Send Message
      </button>
    </form>
  );
};

export default ContactForm;
